import React from "react";
import { NavLink } from "components";
import "./MobileNav.scss";
import "../dropdownLink/DropdownLink.scss";
import "../navLink/NavLink.scss";
import { Stack } from "@mui/material";

function MobileNav() {
  return (
    <>
      <label className="hamburgerButton">
        <input type="checkbox" />
      </label>
      <aside className="sidebar">
        <nav>
          <Stack spacing="xsmall">
            <NavLink label="Home" to="/" />
            <NavLink label="Register" to="/register" />
            <NavLink label="Purpose" to="/about/purpose" />
            <NavLink label="Trustees" to="/about/trustees" />
            <NavLink label="Guidelines" to="/about/guidelines" />
            <NavLink label="History" to="/history" />
            <NavLink label="Store" to="/store" />
            <NavLink label="Gallery" to="/gallery" />
            <NavLink label="About the PBH" to="/pbh/about" />
            <NavLink label="Search the PBH" to="/pbh/search" />
            <NavLink label="Donate" to="/donate" />
            <NavLink label="Contact" to="/contact" />
          </Stack>
        </nav>
      </aside>
    </>
  );
}

export default MobileNav;
